/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintenance_Legend_DisclaimerInputs */



/**
* | output |
* | --- |
* | "The actions indicated in this document may need to be reconsidered based on on-site diagnosis" |
*
* @param {Maintenance_Legend_DisclaimerInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const maintenance_legend_disclaimer = /** @type {((inputs?: Maintenance_Legend_DisclaimerInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintenance_Legend_DisclaimerInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The actions indicated in this document may need to be reconsidered based on on-site diagnosis")
	return /** @type {LocalizedString} */ ("Les actions à mener indiquées dans ce document sont susceptibles d'être à reconsidérer en fonction du diagnostic terrain")
});